/* 🤖 this file was generated by svg-to-ts */
export const matIconTempleHindu: {
  name: 'temple-hindu';
  data: string;
} = {
  name: 'temple-hindu',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 11v2h-2L15 3V1h-2v2h-2.03V1h-2v2.12L6 13H4v-2H2v11h9v-5h2v5h9V11h-2zm-4.69 0H8.69l.6-2h5.42l.6 2zm-1.2-4H9.89l.6-2h3.02l.6 2zM20 20h-5v-5H9v5H4v-5h3.49l.6-2h7.82l.6 2H20v5z"/></svg>`
};
